// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StaticUrlResponse
 */
export interface StaticUrlResponse {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the StaticUrlResponse interface.
 */
export function instanceOfStaticUrlResponse(value: object): value is StaticUrlResponse {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function StaticUrlResponseFromJSON(json: any): StaticUrlResponse {
  return StaticUrlResponseFromJSONTyped(json, false);
}

export function StaticUrlResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StaticUrlResponse {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function StaticUrlResponseToJSON(json: any): StaticUrlResponse {
  return StaticUrlResponseToJSONTyped(json, false);
}

export function StaticUrlResponseToJSONTyped(
  value?: StaticUrlResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
